import {
  RencanaKontrolReferensi,
  RencanaKontrolStatusSrk
} from "@/types/rencanaKontrol";

const BULAN_PENDEK = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mei",
  "Jun",
  "Jul",
  "Agu",
  "Sep",
  "Okt",
  "Nov",
  "Des"
];

export const REFERENSI_LABEL: Record<RencanaKontrolReferensi, string> = {
  skdp: "SKDP",
  res_ranap: "Resume Ranap",
  resep: "Resep"
};

export const STATUS_SRK_META: Record<
  RencanaKontrolStatusSrk,
  { text: string; color: string; textColor: string }
> = {
  berhasil: { text: "BERHASIL", color: "green lighten-5", textColor: "green--text text--darken-3" },
  gagal: { text: "GAGAL", color: "red lighten-5", textColor: "red--text text--darken-3" },
  menunggu: { text: "MENUNGGU", color: "grey lighten-3", textColor: "grey--text text--darken-2" }
};

/** "2024-10-28" → "28 Okt 2024". */
export function tglPanjang(iso: string | null | undefined): string {
  if (!iso || iso.length < 10) return "-";

  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);

  return y && m && d ? `${String(d).padStart(2, "0")} ${BULAN_PENDEK[m - 1]} ${y}` : "-";
}

export function tglAngka(iso: string | null | undefined): string {
  if (!iso || iso.length < 10) return "-";

  const [y, m, d] = iso.slice(0, 10).split("-");

  return `${d}/${m}/${y}`;
}
